var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUnknownUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffd7a3;}.cls-3{fill:#fdc88e;}.cls-4{fill:#734a3e;}.cls-5,.cls-9{fill:#623f33;}.cls-6{fill:#ffe1b2;}.cls-7{fill:#00bea4;}.cls-8{fill:#00ab9a;}.cls-9{font-size:229px;font-family:BrandonGrotesque-Bold, Brandon Grotesque;font-weight:700;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "testimonial_roger_flugzeug_selber_fliegenicon_unknown_user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Backdrop"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 511,
    height: 511
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,1V511H1V1H511m1-1H0V512H512V0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M441.32,574.08l-12-95.85A37.86,37.86,0,0,0,403.74,447l-46.2-15.4a18.93,18.93,0,0,0-18.2,3.4l-13.61-4.54a18.93,18.93,0,0,1-12.94-18V382l40.77-17a56.79,56.79,0,0,0,34.95-52.42V303.1A28.39,28.39,0,0,0,410,256.2c8-29.25,30.62-121.76,6.87-161.33L426.38,57S327,59.37,274.93,75.93L293.86,57S160.75,57,133,104.32h0s-47.33-.39-47.33,56.79c0,20.93,11.67,73.19,16.69,94.67a28.39,28.39,0,0,0,21.18,47.31v9.47A56.8,56.8,0,0,0,158.43,365l40.78,17v30.53a18.93,18.93,0,0,1-12.94,18L172.65,435a18.93,18.93,0,0,0-18.2-3.4L108.26,447a37.86,37.86,0,0,0-25.6,31.22l-12,95.85A28.4,28.4,0,0,0,98.86,606H413.14A28.4,28.4,0,0,0,441.32,574.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M312.79,382H199.21v30.53a18.76,18.76,0,0,1-9.49,16.16C269.11,442.57,312.79,382,312.79,382Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.55,265.24S85.62,187.77,85.62,161.12c0-57.19,47.33-56.79,47.33-56.79h0C160.75,57,293.86,57,293.86,57L274.93,75.93C327,59.37,426.38,57,426.38,57l-9.47,37.86c28.4,47.33-9.47,170.38-9.47,170.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M293.86,57S160.75,57,133,104.32h0s-47.33-.39-47.33,56.79c0,26.65,18.93,104.12,18.93,104.12S301.36,177.29,426.38,57c0,0-99.39,2.37-151.45,18.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.52,246.31V227.38a47.33,47.33,0,0,0-47.33-47.33H170.81a47.33,47.33,0,0,0-47.33,47.33v18.93a28.4,28.4,0,1,0,0,56.79v9.47A56.8,56.8,0,0,0,158.43,365l61.16,25.48A94.65,94.65,0,0,0,256,397.76h0a94.66,94.66,0,0,0,36.41-7.28L353.57,365a56.79,56.79,0,0,0,34.95-52.42V303.1a28.4,28.4,0,1,0,0-56.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M441.32,574.08l-12-95.85A37.86,37.86,0,0,0,403.74,447l-46.2-15.4a18.62,18.62,0,0,0-21.64,7.34,94.55,94.55,0,0,1-159.8,0,18.62,18.62,0,0,0-21.64-7.34L108.26,447a37.86,37.86,0,0,0-25.6,31.22l-12,95.85A28.4,28.4,0,0,0,98.86,606H413.14A28.4,28.4,0,0,0,441.32,574.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M90.55,459.48a37.78,37.78,0,0,0-7.89,18.75l-12,95.85A28.4,28.4,0,0,0,98.86,606h53V544.39a37.87,37.87,0,0,0-9.24-24.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M421.45,459.48a37.78,37.78,0,0,1,7.89,18.75l12,95.85A28.4,28.4,0,0,1,413.14,606h-53v-61.6a37.87,37.87,0,0,1,9.24-24.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.17,345.37a44.37,44.37,0,0,1-11.83-30.32V207.78c30.13-2.26,125.11-10.47,179.84-27.73H170.81a44.49,44.49,0,0,0-9.47,1V181a47.34,47.34,0,0,0-37.86,46.37v18.93a28.4,28.4,0,1,0,0,56.79v9.47A56.79,56.79,0,0,0,158.43,365l61.16,25.48a94.79,94.79,0,0,0,9.14,3.25C201.7,374,183.71,356.67,173.17,345.37Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(204.59 362.91)"
  }, "?"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnknownUser);
export default __webpack_public_path__ + "static/media/icon_unknown_user.6c7889f7a89e60d802a2ad4c86027d1a.svg";
export { ForwardRef as ReactComponent };